export enum AppLocalStorage {
  TOKEN = "authToken",
}
